exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#2C2836",
	"menuActiveText": "#2E63FD",
	"subMenuActiveText": "#2E63FD",
	"menuBg": "#fff",
	"menuHover": "#fff",
	"subMenuBg": "rgba(1, 57, 166, 0)",
	"subMenuHover": "#fff",
	"sideBarWidth": "205px"
};